module.exports = __webpack_public_path__ + "static/media/gslides.d79e4c2a.png";